<template>
  <div>
    <div class="insurance-provider master-table box mt-4">
      <div class="row">
        <div class="col-md-12 offset-md-11">
          <button
            type="submit"
            value=""
            id=""
            class="custom-btn add-btn"
            name=""
            data-bs-toggle="modal"
            data-bs-target="#master_insurance_provider_modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-plus-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
          </button>
        </div>
      </div>
      <table class="table table-bordered mt-3">
        <thead>
          <tr>
            <th scope="col">Sl No.</th>
            <th scope="col">Insurance Provider Name</th>
            <th scope="col">Person Name</th>
            <th scope="col">Contact No.</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody
          v-for="(
            insurance_provider_detail, index
          ) in insurance_provider_details"
          :key="insurance_provider_detail.INSURANCE_PROVIDER_SYS_ID"
        >
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ insurance_provider_detail.INSURANCE_PROVIDER }}</td>
            <td>{{ insurance_provider_detail.PERSON_NAME }}</td>
            <td>{{ insurance_provider_detail.CONTACT_NO }}</td>
            <td class="table-btn">
              <button
                type="button"
                class="custom-btn p-0"
                @click="
                  showModal(
                    insurance_provider_detail,
                    '#master_insurance_provider_edit_modal'
                  )
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-edit"
                >
                  <path
                    d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  ></path>
                  <path
                    d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  ></path>
                </svg>
              </button>
              <button
                type="button"
                class="custom-btn p-0"
                @click="
                  showModal(
                    insurance_provider_detail,
                    '#master_insurance_provider_delete_modal'
                  )
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-trash-2"
                >
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path
                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                  ></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- create modal -->

    <div
      class="modal modal-right fade"
      id="master_insurance_provider_modal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" style="width: 30%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Add Insurance Provider
            </h5>
            <button
              type="button"
              class="btn-normal modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <ValidationObserver ref="insurprovform" v-slot="{ invalid }">
                  <form>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Insurance Provider</label>
                        <input
                          type="text"
                          name="Insurance Provider"
                          placeholder="Enter Insurance Provider Name"
                          v-model="
                            create_insurance_provider.INSURANCE_PROVIDER_NAME
                          "
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              create_insurance_provider.INSURANCE_PROVIDER_NAME !=
                                '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Person Name</label>
                        <input
                          type="text"
                          name="Person Name"
                          placeholder="Enter Person Name"
                          v-model="create_insurance_provider.PERSON_NAME"
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              create_insurance_provider.PERSON_NAME != '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Contact No.</label>
                        <input
                          type="text"
                          name="Contact No."
                          placeholder="Enter Contact No."
                          v-model="create_insurance_provider.CONTACT_NO"
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              create_insurance_provider.CONTACT_NO != '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>

                    <div class="modal-footer-2">
                      <div class="row mt-4">
                        <div class="col-md-5">
                          <button
                            type="button"
                            class="custom-btn custom-success-btn"
                            :disabled="invalid"
                            @click="createInsuranceProvider"
                          >
                            Save
                          </button>
                        </div>
                        <div class="col-md-2">
                          <button
                            type="button"
                            @click="emptyfu"
                            data-bs-dismiss="modal"
                            class="custom-btn custom-danger-btn"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- edit insurance modal -->

    <div
      class="modal modal-right fade"
      id="master_insurance_provider_edit_modal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" style="width: 30%">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Edit Insurance Provider
            </h5>
            <button
              type="button"
              class="btn-normal modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <ValidationObserver
                  ref="insurproveditform"
                  v-slot="{ invalid }"
                >
                  <form>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Insurance Provider</label>
                        <input
                          type="text"
                          name="Insurance Provider"
                          placeholder="Enter Insurance Provider Name"
                          v-model="selected_row.INSURANCE_PROVIDER"
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              selected_row.INSURANCE_PROVIDER != '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Person Name</label>
                        <input
                          type="text"
                          name="Person Name"
                          placeholder="Enter Person Name"
                          v-model="selected_row.PERSON_NAME"
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              selected_row.PERSON_NAME != '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <div class="col-md-12 mt-4">
                        <label class="frm-label">Contact No.</label>
                        <input
                          type="text"
                          name="Contact No."
                          placeholder="Enter Contact No."
                          v-model="selected_row.CONTACT_NO"
                          class="form-control"
                          :class="{
                            'is-invalid': errors[0] != null,
                            'is-valid':
                              errors[0] == null &&
                              selected_row.CONTACT_NO != '',
                          }"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                    <div class="modal-footer-2">
                      <div class="row mt-4">
                        <div class="col-md-5">
                          <button
                            type="button"
                            class="custom-btn custom-success-btn"
                            :disabled="invalid"
                            @click="updateInsuranceProvider"
                          >
                            Update
                          </button>
                        </div>
                        <div class="col-md-2">
                          <button
                            type="button"
                            data-bs-dismiss="modal"
                            class="custom-btn custom-danger-btn"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--- delete modal -->

    <div
      class="modal"
      id="master_insurance_provider_delete_modal"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delete</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteInsuranceProvider"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiEndPoints from "../../endpoints.js";
import { Global } from "@/global.js";

export default {
  data() {
    return {
      insurance_provider_details: [],
      create_insurance_provider: {
        ITEM: "ADD",
        RECORD_SYS_ID: "0",
        INSURANCE_PROVIDER_NAME: "",
        PERSON_NAME: "",
        CONTACT_NO: "",
        CREATED_BY: "",
      },
      selected_row: {},
    };
  },

  mounted() {
    this.getInsuranceProviderInfo();
  },

  methods: {
    emptyfu() {
      this.create_insurance_provider.INSURANCE_PROVIDER_NAME = "";
      this.create_insurance_provider.PERSON_NAME = "";
      this.create_insurance_provider.CONTACT_NO = "";
    },

    getInsuranceProviderInfo() {
      this.axios
        .get(apiEndPoints.insurance_provider_details, {
          params: {
            ITEM: "VIEW_ALL",
            RECORD_SYS_ID: 0,
          },
        })
        .then((response) => {
          //console.log(response);
          //this.insurance_provider_details = response.data.response;
          if (response.data.status == "true") {
            this.insurance_provider_details = response.data.response;
          } else if (
            response.data.status == false ||
            response.data.status == "false"
          ) {
            this.insurance_provider_details = [];
            Global.showErrorAlert(true, "error", response.data.response);
          }
        })
        .catch((err) => {
          //console.log(err);
        });
    },

    createInsuranceProvider() {
      let user_details = JSON.parse(localStorage.getItem("lek_user_details"));
      this.create_insurance_provider["CREATED_BY"] = user_details.UserId;

      this.$refs.insurprovform.validate().then((success) => {
        if (!success) {
          return;
        }
        this.axios
          .post(
            apiEndPoints.create_update_insurance_provider,
            this.create_insurance_provider
          )
          .then((response) => {
            //console.log(response);
            if (response.data.status == "true") {
              Global.showSuccessAlert(true, "success", response.data.response);
              $("#master_insurance_provider_modal").modal("hide");
              this.getInsuranceProviderInfo();
              this.emptyfu();
            } else if (
              response.data.status == false ||
              response.data.status == "false"
            ) {
              Global.showErrorAlert(true, "error", response.data.response);
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      });
    },

    showModal(row, id) {
      this.selected_row = row;
      $(id).modal("show");
    },

    updateInsuranceProvider() {
      let user_details = JSON.parse(localStorage.getItem("lek_user_details"));
      let update_payload = {
        ITEM: "UPDATE",
        RECORD_SYS_ID: this.selected_row.INSURANCE_PROVIDER_SYS_ID,
        INSURANCE_PROVIDER_NAME: this.selected_row.INSURANCE_PROVIDER,
        PERSON_NAME: this.selected_row.PERSON_NAME,
        CONTACT_NO: this.selected_row.CONTACT_NO,
        CREATED_BY: user_details.UserId,
      };

      this.$refs.insurproveditform.validate().then((success) => {
        if (!success) {
          return;
        }
        this.axios
          .post(apiEndPoints.create_update_insurance_provider, update_payload)
          .then((response) => {
            //console.log(response);
            if (response.data.status == "true") {
              Global.showSuccessAlert(true, "success", response.data.response);
              $("#master_insurance_provider_edit_modal").modal("hide");
              this.getInsuranceProviderInfo();
            } else if (
              response.data.status == false ||
              response.data.status == "false"
            ) {
              Global.showErrorAlert(true, "error", response.data.response);
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      });
    },

    deleteInsuranceProvider() {
      let user_details = JSON.parse(localStorage.getItem("lek_user_details"));
      let delete_payload = {
        ITEM: "DELETE",
        RECORD_SYS_ID: this.selected_row.INSURANCE_PROVIDER_SYS_ID,
        CREATED_BY: user_details.UserId,
      };
      this.axios
        .post(apiEndPoints.create_update_insurance_provider, delete_payload)
        .then((response) => {
          $("#master_insurance_provider_delete_modal").modal("hide");
          this.getInsuranceProviderInfo();
        })
        .catch((err) => {
          //console.log(err);
        });
    },
  },
};
</script>
